import { NgModule } from '@angular/core';
import { MuiSpacingDirective } from './mui-spacing.directive';


@NgModule({
  declarations: [MuiSpacingDirective],
  exports: [MuiSpacingDirective]
})
export class MuiSpacingModule {
}
